// The room's chat (Matt, 2026-10-22: "It would be nice to have a little chat
// room on the group solves"). Pure helpers; rooms.js reads and writes, the
// store keeps the list, ChatPanel draws it.

/** The rules' cap on one message. */
export const CHAT_MAX = 300;
/** How many of the latest messages a room loads. */
export const CHAT_KEEP = 200;

/** Trimmed, inner runs of spaces squeezed (newlines kept), capped. '' for nothing. */
export function cleanChatText(text) {
  return String(text ?? '')
    .replace(/\r\n?/g, '\n')
    .replace(/[^\S\n]+/g, ' ')
    .replace(/ ?\n ?/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
    .slice(0, CHAT_MAX)
    .trim();
}

/** The chat node's value as a list, oldest first; malformed rows dropped. */
export function chatList(value) {
  return Object.entries(value || {})
    .filter(([, m]) => m && typeof m.text === 'string' && m.uid)
    .map(([id, m]) => ({ id, ...m }))
    .sort((a, b) => (a.at || 0) - (b.at || 0) || (a.id < b.id ? -1 : 1));
}

/** Messages from someone else after `readAt` (a server time). */
export function unreadCount(messages, myUid, readAt) {
  return (messages || []).filter((m) => m.uid !== myUid && (m.at || 0) > (readAt || 0)).length;
}

/**
 * The messages in `next` that weren't in `prev`, from someone else - what
 * deserves a pop-up. The first load (prev null) is history, not news.
 */
export function freshFromOthers(prev, next, myUid) {
  if (!prev) return [];
  const seen = new Set(prev.map((m) => m.id));
  return (next || []).filter((m) => !seen.has(m.id) && m.uid !== myUid);
}

/** Read marks live per room, on this device. */
const readKey = (roomId) => `crossword.chatRead.${roomId}`;
export function loadChatRead(roomId) {
  try { return Number(localStorage.getItem(readKey(roomId))) || 0; } catch { return 0; }
}
export function saveChatRead(roomId, at) {
  try { localStorage.setItem(readKey(roomId), String(at)); } catch { /* private mode */ }
}
